import { consumerChatTransport as e } from "./consumerChatTransport.mjs";
import { createContext as t, useContext as n, useMemo as r } from "react";
import { useMyProfile as i } from "@maat/store-profile";
import { jsx as a } from "react/jsx-runtime";
//#region src/transport/ChatTransportContext.tsx
var o = t(void 0), s = ({ transport: e, children: t }) => /* @__PURE__ */ a(o.Provider, {
	value: e,
	children: t
}), c = () => n(o) ?? e, l = () => {
	let e = c(), t = i(), { identity: n } = e;
	return r(() => n ?? {
		id: t.id,
		first_name: t.first_name,
		last_name: t.last_name
	}, [
		n,
		t.id,
		t.first_name,
		t.last_name
	]);
};
//#endregion
export { s as ChatTransportProvider, l as useChatIdentity, c as useChatTransport };
